import { Mail, Phone, Calendar, ChevronRight } from "lucide-react";
import { STATUS_STYLES } from "./messageStatus";

export default function MessageRow({ row, onSelect }) {
    const status = row.status || "new";
    return (
        <li>
            <button
                onClick={() => onSelect(row)}
                className="w-full text-left p-5 hover:bg-[#F7F5F0] transition-colors flex items-start gap-4"
                data-testid={`message-row-${row.id}`}
            >
                <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-3 mb-1.5">
                        <p className="font-[Outfit] text-[16px] font-semibold truncate">
                            {row.name}
                        </p>
                        <span
                            className={`text-[10.5px] uppercase tracking-wider font-medium px-2 py-0.5 rounded-full border ${STATUS_STYLES[status]}`}
                        >
                            {status}
                        </span>
                    </div>
                    <div className="flex items-center gap-4 text-[12.5px] text-[#6F6B63] flex-wrap">
                        <span className="flex items-center gap-1.5">
                            <Mail className="h-3 w-3" />
                            {row.email}
                        </span>
                        {row.phone && (
                            <span className="flex items-center gap-1.5">
                                <Phone className="h-3 w-3" />
                                {row.phone}
                            </span>
                        )}
                        {row.subject && <span>· {row.subject}</span>}
                        <span className="flex items-center gap-1.5">
                            <Calendar className="h-3 w-3" />
                            {new Date(row.created_at).toLocaleDateString()}
                        </span>
                    </div>
                    <p className="mt-2 text-[13px] text-[#1A2230]/75 line-clamp-2">
                        {row.message}
                    </p>
                </div>
                <ChevronRight className="h-4 w-4 text-[#8F8B83] mt-1 shrink-0" />
            </button>
        </li>
    );
}
